import { Fade, IconButton, Menu, MenuItem } from "@mui/material";
import { Box } from "@mui/system";
import { exportCanvasAsPNG, exportCSV } from '../../Utility/Utility';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useState } from "react";

const DownloadButton = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDownloadPNG = () => {
        setAnchorEl(null);
        exportCanvasAsPNG(props.canvas, props.fileName, props.isMap, props.imageAsset);
    };

    const handleDownloadCSV = () => {
        setAnchorEl(null);
        exportCSV(props.csv, props.fileName);
    };

    return (
        <Box display='flex' justifyContent='flex-end'>
            {(props.canvas || props.imageAsset) && props.fileName &&
                <IconButton sx={{ color: '#707070' }} component="span" onClick={handleClick}>
                    <FileDownloadOutlinedIcon fontWeight={400} fontSize='large' />
                </IconButton>
            }
            <Menu
                id="fade-menu"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <MenuItem onClick={handleDownloadPNG}>Download PNG</MenuItem>
                {props.csv && <MenuItem onClick={handleDownloadCSV}>Download CSV</MenuItem>}
            </Menu>
        </Box>
    );
}

export default DownloadButton;